import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { showMessage } from '../../../store/actions/messages.actions';
import { contractWritePermission } from '../../../store/selectors/account.selector';
import store from '../../../store/store';
import { deleteSubscriber, setSubscribersRefresh } from '../../../store/actions/subscribers.actions';
import formatPhone from '../../../utils/formatPhone';

const SubscriberDeleteDialog = ({ handleClose, ...props }) => {
  const dispatch = useDispatch();
  const { action1, actionId1 } = useParams();

  const editPermission = useSelector(contractWritePermission);

  const subscribers = useSelector((state) => state.subscribers.list);
  const [subscriberSelected, setSubscriberSelected] = useState({});
  const [deleteDialog, setDeleteDialog] = useState(false);

  // state effect
  useEffect(() => {
    const subscriberFromList = actionId1 && (subscribers.find((item) => item.id === actionId1));
    if (action1 === 'delete') {
      setDeleteDialog(true);
    } else {
      setDeleteDialog(false);
    }
    if (action1 === 'delete' && actionId1) {
      setSubscriberSelected({
        ...subscriberFromList,
      });
    }
  }, [action1, actionId1, subscribers]);

  const onDeleteSubscriber = async () => {
    try {
      await store.dispatch(deleteSubscriber(actionId1));
      dispatch(showMessage({ open: true, text: 'Абонент успешно удалён', severity: 'success' }));
      handleClose(null, 'success');
      setTimeout(() => dispatch(setSubscribersRefresh()), 500);
    } catch (error) {
      console.log(error);
      dispatch(showMessage({ open: true, text: `Не удалось удалить. ${error.message}`, severity: 'error' }));
    }
  };

  return (
    <>
      {/* delete dialog */}
      <Dialog {...props} open={deleteDialog} onClose={handleClose} disableRestoreFocus>
        <DialogTitle>
          <Box sx={{ fontSize: '22px' }}>
            Удалить абонента?
          </Box>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: '8px' }}>
          <Typography
            color="textSecondary"
            variant="body1"
          >
            <span>Абонент с телефоном </span>
            <strong>{formatPhone(subscriberSelected.phone)}</strong>
            <span> будет удалён</span>
          </Typography>
          <Grid
            container
            justifyContent="space-between"
            spacing={2}
            sx={{
              pb: 2,
              pt: 4,
            }}
          >
            <Grid
              item
            >
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                onClick={handleClose}
              >
                Отменить
              </Button>
            </Grid>
            <Grid
              item
            >
              {editPermission && (
                <Button
                  variant="contained"
                  color="purple"
                  fullWidth
                  onClick={onDeleteSubscriber}
                >
                  Удалить
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  );
};

SubscriberDeleteDialog.propTypes = {
  handleClose: PropTypes.func,
};

SubscriberDeleteDialog.defaultProps = {
  handleClose: null,
};

export default SubscriberDeleteDialog;
